import React from 'react';
import './ww-echo-box.scss';
import { WWEchoes } from '../data/ww-echoes';
import { WWEchoBox } from './ww-echo-box';

interface IProps {
  name: string;
  mode: string;
  level?: number[];
  onProfile?: boolean;
  inline?: boolean;
}

export const WWEchoEntry: React.FC<IProps> = ({
  name,
  mode,
  level,
  onProfile,
  inline
}) => {
  const echo = WWEchoes.find((echo) => echo.Name === name);

  return (
    <>
      {mode === 'icon' && (
        <WWEchoBox
          echo={echo}
          level={level}
          onProfile={onProfile}
          inline={inline}
        />
      )}
    </>
  );
};
